import {Button, CheckboxProps} from '@material-ui/core';
import cn from 'classnames';
import * as React from 'react';
import {FormattedMessage} from 'react-intl';
import {SelectButton} from './SelectButton';
import {NO_GROUP} from './LabelView';
import './FileViewerHeaderLabel.scss';

export type FileViewerHeaderLabelProps = {
  className?: string;
  count: number;
  selected: number;
  label?: string | null;
  showSelector?: boolean;
  onClick?(label?: string | null): void;
  onSelectAll?(value: boolean): void;
} & Pick<CheckboxProps, 'indeterminate' | 'checked'>;

export const FileViewerHeaderLabel = ({
  className,
  count,
  selected,
  label,
  showSelector = false,
  onClick,
  checked,
  indeterminate,
  onSelectAll = () => {},
}: FileViewerHeaderLabelProps) => (
  <div className={cn('file-viewer-header-label', className)}>
    {showSelector && (
      <SelectButton
        onChange={(e, val) => onSelectAll(val)}
        checked={checked}
        indeterminate={indeterminate}
      />
    )}
    <Button onClick={() => onClick?.(label)} disabled={!Boolean(onClick)}>
      <div className="file-viewer-header-label__title">
        <span>
          {label === NO_GROUP || !label ? (
            <FormattedMessage id="fileViewer.unlabeled" />
          ) : (
            label
          )}
        </span>
        &nbsp; ({count} <FormattedMessage id="fileViewer.files" />)
        {selected > 0 && (
          <span className="file-viewer-header-label__selected">
            &nbsp; ({selected} <FormattedMessage id="fileViewer.selected" />)
          </span>
        )}
      </div>
    </Button>
  </div>
);
